"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/PetrolPump.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PetrolPump = function PetrolPump(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 139.36 152.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Petrol Pump Icon"), _react2.default.createElement("g", {
    className: "petrol-pump",
    "data-name": "petrol pump",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "pump",
    d: "M138.8 37.9c-4-7.2-21.9-25.4-25.8-19.3-.8 1.2 2 17.7 7.1 31.6 1.7 4.6 9.1 2.6 12.8 2.3h.2c-.2 19.9-.9 49.2-2.1 55-.5 2.6-2 4-4.2 4.1h-.1a6.82 6.82 0 0 1-6.3-5.4c-1.5-6.3-1.5-28.1-1.3-36a3.08 3.08 0 0 0-2.9-3.1h-7.9a4.47 4.47 0 0 0-3.6-2v-57A8.52 8.52 0 0 0 96 0H30.7A8.47 8.47 0 0 0 22 8.2v118.2H8.2a8.24 8.24 0 0 0-8.2 8.2v9.7a8.24 8.24 0 0 0 8.2 8.2h109.4a8.24 8.24 0 0 0 8.2-8.2v-9.7a8.24 8.24 0 0 0-8.2-8.2h-12.8V76.2a4.82 4.82 0 0 0 4.2-3h4.2c-.1 7.7-.1 27.7 1.5 34.4a12.83 12.83 0 0 0 12.1 10h.2c5-.1 8.8-3.5 9.9-8.8 1.7-8.4 2.2-54.2 2.3-66.1a8.71 8.71 0 0 0-.4-4.8zm-6.8 1.4c-.4 3-7.7 7-10 2 0 0 1.5-5.2 1.1-7.4-.4-1.9-3-9.2-3-9.2s12.6 8.9 11.9 14.6zM115.1 132c3.8 0 3.9 3.1 3.9 6.9v1.2c0 3.8-.1 6.9-3.9 6.9H9.6c-3.8 0-3.9-3.1-3.9-6.9v-1.2c0-3.8.1-6.9 3.9-6.9h18.7V12.9c0-3.8 1.3-6.9 5.4-6.9h59.2c4.1 0 5.4 3.1 5.4 6.9V132h16.8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "display",
    d: "M82.4 16.6H44.7a8.45 8.45 0 0 0-8.4 8.4v37.7a8.45 8.45 0 0 0 8.4 8.4h37.7a8.45 8.45 0 0 0 8.4-8.4V25a8.45 8.45 0 0 0-8.4-8.4zm2.7 46.1a2.8 2.8 0 0 1-2.8 2.8H44.7a2.8 2.8 0 0 1-2.8-2.8V25a2.8 2.8 0 0 1 2.8-2.8h37.7a2.8 2.8 0 0 1 2.8 2.8v37.7h-.1z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = PetrolPump;